import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobAttachmentChipType } from 'src/app/shared/common/enums/attachments/job-attachment-type';
import { JobChipData, SurveyJob } from 'src/app/shared/survey-data-services/survey-job';

@Component({
    selector: 'survey-job-list-item',
    templateUrl: 'survey-job-list-item.component.html'
})
export class SurveyJobListItemComponent implements OnInit {
    @Input() job?: SurveyJob;
    @Input() isDownloading: boolean = false;
    @Output() select = new EventEmitter<SurveyJob>();
    @Output() download = new EventEmitter<SurveyJob>();
    @Output() visibilityToggle = new EventEmitter<SurveyJob>();

    JobAttachmentChipType = JobAttachmentChipType;
    jobTags: JobChipData[] = [];

    ngOnInit(): void {
        this.jobTags = this.mapTagsForJobChip();
    }

    // Modify this method when you need to handle the selection of a job
    onSelect() {
        this.select.emit(this.job);
    }

    onDownload(event: any) {
        event.stopPropagation();
        this.download.emit(this.job);
    }

    onVisibilityToggle(event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();
        // Toggle the visibility state
        this.job.visible = !this.job.visible;
        // Emit the job with updated visibility
        this.visibilityToggle.emit(this.job);
    }

    disableClick(event: MouseEvent) {
        // NOTE: this disable emit of onSelect() to prevent going to job detail page

        event.stopPropagation();
        event.preventDefault();
    }

    // map tags for job
    mapTagsForJobChip() {
        return (
            this.job?.tags.map(tag => ({
                label: tag
            })) || []
        );
    }
}
